export enum Contexts {
  ADMIN = "admin",
  CLIENT = "client",
  GUEST = "guest",
  STAFF = "staff",
  /**
   * LEGACY user context
   * @deprecated Use `STAFF` instead.
   */
  USER = "user",
  // this should be used only with {withAccessToken: false}
  NO_CONTEXT = ""
}
